import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import HomePage from "@/pages/HomePage";
import StemsPage from "@/pages/StemsPage";
import HistoryPage from "@/pages/HistoryPage";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/lib/auth";

/**
 * Router wrapper that intercepts the /#session_id=... fragment BEFORE the
 * normal <Routes> match — otherwise the fragment lives on the target route
 * and races the AuthProvider's /auth/me probe.
 *
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS —
 * THIS BREAKS THE AUTH.
 */
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/stems" element={<StemsPage />} />
      <Route path="/history" element={<HistoryPage />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}
